import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import { Button, Flex, Text, useMantineTheme } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";

import { MINT_URL } from "~config";
import { InternalLink } from "~features/MintPage/components/InternalLink";

import useMintState from "../../../hooks/useMintState";

import { MintCardProps } from "./MintCard";
import MintCardButton, { MintButtonPosition } from "./MintCardButton";
import CardStats from "./MintCardStats";

const MintCardSmall = ({
  onMintClick,
  seriesTokeMinted,
  showGateRequirementsModal,
  showWarningModals,
}: MintCardProps) => {
  const {
    disabledCardText,
    isMarketplaceNoticeShown,
    loadingClaimMint,
    collection,
    mintDataLoading,
    loadingUserCurrencyAllowance,
  } = useMintState();
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm - 1}px)`);
  const marketplaceLink = MINT_URL.tokens.marketplace.replace(
    ":collectionId",
    collection?.id ?? ""
  );

  return (
    <Flex
      gap={isMobile ? 16 : 32}
      direction={isMobile ? "column" : "row"}
      align={isMobile ? undefined : "center"}
      justify={isMobile ? undefined : "right"}
    >
      <CardStats smallSize />
      {disabledCardText ? (
        isMarketplaceNoticeShown ? (
          <Button
            component={InternalLink}
            to={marketplaceLink}
            color={SECONDARY_COLOR}
          >
            View on marketplace
          </Button>
        ) : (
          <Text weight={500} size={isMobile ? 14 : 18}>
            {disabledCardText.title}
          </Text>
        )
      ) : (
        <MintCardButton
          miw={120}
          fullWidth
          mintLabel="Mint"
          onMintClick={onMintClick}
          loading={
            loadingClaimMint || mintDataLoading || loadingUserCurrencyAllowance
          }
          showErrorIcon={false}
          disabledMint={seriesTokeMinted}
          size={isMobile ? "xl" : "lg"}
          enableCrossChainMint={
            collection?.flagVariations.enableCrossChainMinting
          }
          showGateRequirementsModal={showGateRequirementsModal}
          showWarningModals={showWarningModals}
          buttonPosition={MintButtonPosition.BottomBar}
        />
      )}
    </Flex>
  );
};

export default MintCardSmall;
